import { Link } from 'react-router-dom';
import React, { FC } from 'react';
import styles from './companyLogo.module.scss';
import cn from 'classnames';

type CompanyLogoProps = {
    src: string;
    href: string;
    alt?: string;
    width?: number;
    height: number;
    className?: string;
};

export const CompanyLogo: FC<CompanyLogoProps> = ({
    alt,
    href,
    height,
    width,
    src,
    className,
}) => (
    <Link to={href ?? '#'} className={cn(styles.logo, [className])}>
        <img src={src} alt={alt} width={width} height={height} />
    </Link>
);
